<template>
  <div class="power-switch-page">
    <div class="page-card" >
         <el-button
                  size="mini"
                  type="primary"
                  @click="toCloundPlatform"
                >云台设置</el-button>


           <el-button
                  size="mini"
                  type="primary"
                  @click="tooutdoorRunningConfig"
                >设备配置</el-button>

         <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="onIssueAnOrder"
                >户外跑发令</el-button> -->
        <el-button
                  size="mini"
                  type="primary"
                  @click="onGetHttp"
                >户外跑发令</el-button>
                
       <!-- <div class="device-select-row">
            <el-select
              v-model="selectedTimerDevice"
              placeholder="请选择设备"
              size="mini"
              style="width: 100%;"
              value-key="code"
              @change="deviceListSelectionChange"
            >
              <el-option
                v-for="item in deviceList"
                :key="item.code"
                :label="item.remark"
                :value="item"
              />
            </el-select>
          </div> -->
       
      

    </div>

  </div>
</template>

<script>
import { Dialog } from 'vant';
import {  getFlowableSchoolCorxInfoList ,save,saveToo,getFlowableSchoolCorxInfoTimeList
  ,selectSchoolDeviceList,selectSchoolDeviceStatus,chooseDeviceProject,setWeekDeviceInfo,selectWeekDeviceInfo,
  selectProjectByHwp,selectConfigurationByHwp,insertConfigurationByHwp} 
  from "@/api/teacher/outdoorRunning.js";
import moment from 'moment';

export default {
  data() {
    return {
      teacherTitleInfo:{},
      deviceList: [
        { id: 1, deviceName: '项目1', status: '结束' },
        { id: 2, deviceName: '项目2', status: '开始' },
      ],

      projectList: [
        { projectCode: "tiaotiao", projectName: '活力15' },
        { projectCode: "RopeSkippingPro", projectName: '跳绳' },
        { projectCode: "Jump", projectName: '立定跳远' },
        { projectCode: "LanQiu", projectName: '篮球拍球' },
        { projectCode: "PaiQiu", projectName: '排球颠球' },
        { projectCode: "Home", projectName: '画廊（选择项目）' },
      ],
      weekList: [
        { id: "1", name: '周一' },
        { id: "2", name: '周二' },
        { id: "3", name: '周三' },
        { id: "4", name: '周四' },
        { id: "5", name: '周五' },
        { id: "6", name: '周六' },
        { id: "7", name: '周日' },
      ],
      weekTimeList:[],
      submitData:{

      },
      selectedprojectCode:'',
      deviceData:{},
      selectedDevices: [],
      selectedDevicesObj: [], // 选中的项目对象
      selectedTimerDevice: '', // 新增：定时设置选中的项目
      timerSettings: {
        timeRanges: [
          { startTime: '', endTime: '' }
        ]
      },
      weekCheckList:[],
      configurationByHwp:[],
      ProjectByHwp:[],
      projectCodeHwpList:[]
    };
  },
  mounted () {
   this.teacherTitleInfo =  JSON.parse(sessionStorage.getItem('teacherTitleInfo'))
   this.getList()
   
  },
  methods: {
    onGetHttp(){

      this.$router.push({
        path: '/outdoorRunning/WiFiCheck',
      });
      
    },
    onIssueAnOrder(){
      this.$router.push({
        path: '/outdoorRunning/WiFiCheck',
      });
    },
    toCloundPlatform(){
      this.$router.push({
        path: '/outdoorRunning/cloudPlatform',
      });
    },
    tooutdoorRunningConfig(){
      this.$router.push({
        path: '/outdoorRunning/outdoorRunningConfig',
      });
    },
    submit(){
        if (!this.selectedDevicesObj.code||this.selectedDevicesObj.code=='') {
            return this.$toast('请选择设备！');
        }
            Dialog.confirm({
        title: '提示',
        message: '是否保存配置项？！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.insertConfigurationByHwp()
        })
        .catch(() => {});


    
    },
    insertConfigurationByHwp(){
            let data = {
        deviceId: this.selectedDevicesObj.code,
        relList:this.configurationByHwp,
        projectCodeList:this.projectCodeHwpList
        }
        insertConfigurationByHwp(data).then(res=>{
        this.$toast('操作成功');

        })
    },
    selectConfigurationByHwp(){
        selectConfigurationByHwp({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.selectedDevicesObj.code,
            }).then(res=>{
              console.log(res.data.body);
            this.configurationByHwp = res.data.body||[]
            this.projectCodeHwpList = []
            res.data.data.forEach(el=>{
              this.projectCodeHwpList.push(el.projectCode)
            })

            })
            selectProjectByHwp({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.selectedDevicesObj.code,
            }).then(res=>{
              console.log(res.data.body);
            this.ProjectByHwp = res.data.body||[]

            })

    },
    async weekSelectionChange(){
      if (this.submitData.week&&this.submitData.week!=='') {
      await this.selectWeekDeviceInfo()
      }
      let weekTimeList = []
      this.weekTimeList?.forEach(item=>{
        if(item.week == this.submitData.week){
          weekTimeList.push(item)
        }
      })
          // { startTime: '', endTime: '' }
      if (weekTimeList.length==0) {
      this.$set(this.timerSettings,"timeRanges",[
          { startTime: '', endTime: '' }
        ])
        
      }else{
      this.$set(this.timerSettings,"timeRanges",weekTimeList)

      }
    },
    projectListSelectionChange(val){

    },
    changeProjectCode(){
      Dialog.confirm({
        title: '提示',
        message: '切换成功后，设备将于20s后切换！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.chooseDeviceProject()
        })
        .catch(() => {});
    },
    chooseDeviceProject(){
      chooseDeviceProject({
        schoolCode: this.teacherTitleInfo.schoolCode,
        projectCode: this.deviceData.projectCode,
        deviceId: this.deviceData.code,
            }).then(res=>{
              console.log(res);
        this.$toast('操作成功');

            })
    },
   async selectWeekDeviceInfo(){
     await selectWeekDeviceInfo({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.deviceData.code,
        week: this.submitData.week,
            }).then(res=>{
              console.log(res);
              this.weekTimeList = res.data.body
              

            })
    },
    getList(){

   

			//  ：设备类型(0,算力机;1,室外项目;2,闸机;3,查询一体机;4,大屏;5,手表,6,萌芽版)
      selectSchoolDeviceList({
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
        projectCode:"hwp"
            }).then(res=>{
              console.log(res);
              
                this.deviceList = res.data.body
                //过滤数据

            })
        },
      saveToo(openOrClose) {
			// openOrClose ：继电器模式（0:断开，1:闭合）
      saveToo({
        isCover: 1,
        mqttMode: 0,
        openOrClose: openOrClose,
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
        }).then(res=>{
          this.$dialog
        .alert({
          message: '操作成功，两分钟后查看状态！！',
          showCancelButton: false
        })
        .then(() => {
        })
          this.getList()

        })
        },
    confirmBatchPowerOn() {
      // if (!this.selectedDevices.length) {
      //   this.$toast('请先选择项目');
      //   return;
      // }
      Dialog.confirm({
        title: '提示',
        message: '确定要开启项目吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.saveToo(1);
        })
        .catch(() => {});
    },
    
    confirmBatchPowerOff() {
      // if (!this.selectedDevices.length) {
      //   this.$toast('请先选择项目');
      //   return;
      // }
      Dialog.confirm({
        title: '提示',
        message: '确定要关闭项目吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.saveToo(0);
        })
        .catch(() => {});
    },

    confirmSetTimer() {
      if (!this.deviceData.projectCode||this.deviceData.projectCode=='') {
        this.$toast('请先选择项目');
        return;
      }

      const valid = this.timerSettings.timeRanges.some(
        t => t.startTime && t.endTime
      );
      if (!valid) {
        this.$toast('请至少设置一个完整的时间段');
        return;
      }
      Dialog.confirm({
        title: '提示',
        message: '确定要设置定时切换项目吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.save();
        })
        .catch(() => {});
    },

    batchPowerOn() {
      console.log('批量开始', this.selectedDevices);
    },
    batchPowerOff() {
      console.log('批量结束', this.selectedDevices);
    },
    deviceListSelectionChange(val) {
      this.selectedDevicesObj = val
      selectSchoolDeviceStatus({ deviceId: val.code,schoolCode:val.schoolCode }).then(res => {
        console.log(res);
        this.deviceData = res.data.body||{}
        
        this.$set(this.deviceData, 'projectCode', this.deviceData.chooseProjectCode||this.deviceData.projectCode)
      });
      this.selectConfigurationByHwp()
    },
    save() {
      console.log('设置定时', {
        deviceId: this.selectedTimerDevice,
        timeRanges: this.timerSettings.timeRanges
      });
   
			// flowableSchoolCorxTime：[{
			//     id：定时记录ID
			//     corxCode ：设备编码
			//     week：星期（1,2,3,4,5,6,7）
      // week: this.weekCheckList
			//     startTime ：开始时间
			//     endTime ：截止时间
			// }],
      let weekList = []

      if (this.timerSettings.timeRanges.length > 0) {
        this.timerSettings.timeRanges.forEach((item, index) => {
          weekList.push({
            projectCode: item.projectCode,
            week: this.submitData.week,
            startTime: item.startTime,
            endTime: item.endTime,
          });
        });
      } else {
        this.$toast('请至少设置一个完整的时间段');
        return;
      }
      let data = {
        deviceId: this.deviceData.code,
        schoolCode: this.teacherTitleInfo.schoolCode,
        weekTimeList:weekList,
      }
      setWeekDeviceInfo(data).then(res => {

        this.$notify({ type: "success", message: '操作成功' })

        // this.timerSettings.timeRanges=[
        //   { startTime: '', endTime: '' }
        // ]
        // this.selectedTimerDevice = ''
        // this.getList();
      });
    },
    addTimeRange() {
      this.timerSettings.timeRanges.push({ startTime: '', endTime: '' });
    },
    removeTimeRange(idx) {
      this.timerSettings.timeRanges.splice(idx, 1);
    },
    // handleSelectionChange(val) {
    //   this.selectedDevices = val.slice();
    // },
    getRowKey(row) {
      return row.id;
    },
  },
};
</script>


<style lang="less" scoped>
.power-switch-page {
  padding: 10px;
  background-color: #f5f7fa;
// background-color: #fff;
  height: calc(100vh - 20px);
}

.page-card {
//   max-width: 800px;
//   margin: 0 auto;
background-color: #fff;
padding: 10px;
  border-radius: 6px;
}

.card-header {
//   padding: 10px 0;
}

.deviceBox{
  font-size: 12px;
  .deviceBox_li{
    display: flex;
    line-height: 35px;
  }
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin: 0;
}

.content-section {
  margin-bottom: 20px;
}

.custom-table {
//   box-shadow: 0 2px 12px 0 rgba(0,0,0,.05);
}

.control-panel {
  /* background: #f8f9fb; */
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  text-align: center;
}

.panel-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 12px;
  text-align: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.timer-section {
//   background: #f8f9fb;
  padding: 15px;
  border-radius: 6px;
}

.timer-form {
  max-width: 400px;
  margin: 0 auto;
}

.time-picker {
  width: 160px;
}

.form-button {
  text-align: center;
  margin-top: 20px;
}

.device-select-row {
  margin-bottom: 10px;
}

.timer-range-row {
  /* display: flex; */
  /* align-items: center; */
  gap: 10px;
  margin-bottom: 8px;
}

.remove-range-btn {
}


</style>